import { Link, useLocation } from "react-router-dom";

import {
  DropdownMenuItem,
  SidebarMenuSubButton,
  SidebarMenuSubItem,
} from "@alaffia-technology-solutions/ds";
import { cn } from "@alaffia-technology-solutions/tailwind-utils";

// Helper to convert label to kebab-case for data-testid
const toKebabCase = (str: string) => str.toLowerCase().replace(/\s+/g, "-");

type NavigationSubItemProps =
  | {
      to: string;
      icon?: React.ComponentType<{ className?: string }>;
      label: string;
      variant?: "sidebar" | "dropdown";
      onClick?: never;
    }
  | {
      to?: never;
      icon?: React.ComponentType<{ className?: string }>;
      label: string;
      variant?: "sidebar" | "dropdown";
      onClick: () => void;
    };

export const NavigationSubItem = ({
  to,
  icon: Icon,
  label,
  variant = "sidebar",
  onClick,
}: NavigationSubItemProps) => {
  const location = useLocation();
  const isActive = to ? location.pathname?.startsWith(to) : false;
  const dataCy = `nav-submenu-${toKebabCase(label)}`;

  const content = (
    <>
      {Icon && <Icon />}
      <span>{label}</span>
    </>
  );

  if (variant === "dropdown") {
    if (onClick) {
      return (
        <DropdownMenuItem
          onClick={onClick}
          className={cn(isActive && "af-bg-accent af-text-accent-foreground")}
        >
          {content}
        </DropdownMenuItem>
      );
    }
    return (
      <DropdownMenuItem
        asChild
        className={cn(isActive && "af-bg-accent af-text-accent-foreground")}
      >
        <Link to={to}>{content}</Link>
      </DropdownMenuItem>
    );
  }

  if (onClick) {
    return (
      <SidebarMenuSubItem>
        <SidebarMenuSubButton onClick={onClick} data-testid={dataCy}>
          {content}
        </SidebarMenuSubButton>
      </SidebarMenuSubItem>
    );
  }

  return (
    <SidebarMenuSubItem>
      <SidebarMenuSubButton asChild isActive={isActive} data-testid={dataCy}>
        <Link to={to}>{content}</Link>
      </SidebarMenuSubButton>
    </SidebarMenuSubItem>
  );
};
